import { APIService } from "../utilities/Constants";
import { apiPatch, apiPost } from "./utils/apiUtils";
import { ErrorHandler } from "./utils/errorUtils";
import { generateHeaders } from "./utils/headerUtils";
import { handleError403Introspection } from "./user";
import { getUserIdFromToken } from "../utilities/HelperFunctions";
import { messages } from "../../src/resources/strings";

const headerConfig = {
  isForPDF: false,
  isUserAuthRequired: true,
  isAppAccessTokenRequired: false,
  scope: "write:user:update",
};
//API :: Reset Password
export const resetPasswordApi = async (object: any) => {
  const customErrorHandlers: ErrorHandler[] = [
    {
      case: 403,
      onError: () => {
        handleError403Introspection();
      },
    },
    {
      case: 400,
      onError: () => {
        return {
          errorCode: messages.error.currentPasswordDidNotMatch,
        };
      },
    },
  ];

  const params = JSON.stringify({
    current_password: object.currentPassword,
    password: object.password,
    confirm_password: object.confirmPassword,
  });
  const header = await generateHeaders(headerConfig);
  const userId = getUserIdFromToken(header.Authorization);
  const response = await apiPatch(
    APIService.harmony,
    `/user/${userId}/password/change`,
    params,
    headerConfig,
    customErrorHandlers
  );
  if (response.status === 200) {
    return {
      response: response.data,
      errorCode: messages.error.noError,
    };
  } else if (response.errorCode) {
    return {
      errorCode: response.errorCode,
    };
  } else {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};

//API :: Reset Password
export const forgotPasswordApi = async () => {
  const customErrorHandlers: ErrorHandler[] = [
    {
      case: 403,
      onError: () => {
        handleError403Introspection();
      },
    },
    {
      case: 400,
      onError: () => {
        return {
          errorCode: messages.error.currentPasswordDidNotMatch,
        };
      },
    },
  ];

  const header = await generateHeaders(headerConfig);
  const userId = getUserIdFromToken(header.Authorization);
  const response = await apiPost(
    APIService.harmony,
    `/user/${userId}/password/reset`,
    {},
    headerConfig,
    customErrorHandlers
  );
  if (response.status === 200) {
    return {
      response: response.data,
      errorCode: messages.error.noError,
    };
  } else {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};
